export default class UserWorkHistoryJwtService {
  axiosIns = null

  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  create(payload = {}) {
    return this.axiosIns.post(`${this.jwtConfig.main.userWorkHistoryEndpoint}`, payload)
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.userWorkHistoryEndpoint}/${id}`, payload)
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.userWorkHistoryEndpoint, {
      params
    })
  }

  delete(id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.userWorkHistoryEndpoint}/${id}`)
  }

  get(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.userWorkHistoryEndpoint}/${id}`)
  }
}
